import React, { useState, useEffect } from "react";
import API_BASE_URL from "../../../apiconfig";
import {
    FaBars,
    FaTimes,
    FaBookOpen,
    FaLayerGroup,   // 🔥 already imported
    FaUser,
    FaMapMarkerAlt,
    FaCamera,
    FaChevronRight,
    FaCheckCircle,
    FaCreditCard,
    FaCommentDots,
    FaSignOutAlt,
    FaTicketAlt,
    FaListAlt
} from "react-icons/fa";
import "./sidebar.css";

function Sidebar({ active, setActive, step }) {
    const [openMenu, setOpenMenu] = useState(false);
    const [downloadMenu, setDownloadMenu] = useState(false);
    const [complainMenu, setComplainMenu] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);
    const [showChallengeBox, setShowChallengeBox] = useState(true);

   

    useEffect(() => {
        const checkTime = () => {
            const now = new Date();

            // Today 7:00 PM
            const closeTime = new Date();
            closeTime.setHours(19, 0, 0, 0);
            //closeTime.setHours(18, 13, 0, 0);

            setShowChallengeBox(now < closeTime);
        };

        checkTime();

        const interval = setInterval(checkTime, 60000); // check every minute

        return () => clearInterval(interval);
    }, []);


    return (
        <>
            {/* 🔥 Mobile Top Bar */}
            <div className="mobile-header">
                <FaBars onClick={() => setMobileOpen(true)} />
                <span>Menu</span>
            </div>

            {/* 🔥 Overlay */}
            {mobileOpen && (
                <div
                    className="overlay"
                    onClick={() => setMobileOpen(false)}
                ></div>
            )}

            {/* 🔥 Sidebar */}
            <div className={`sidebar ${mobileOpen ? "open" : ""}`}>

                {/* Close button */}
                <div className="close-btn">
                    <FaTimes onClick={() => setMobileOpen(false)} />
                </div>

                {/* Header */}
                <div className="sidebar-header">
                    <img src="/ASTU_JMEE_JLEE/img/astulogo.png" alt="ASTU Logo" />

                    <h3>ASTU</h3>

                    <p>JMEE & JLEE Portal</p>

                    <span>Assam Science and Technology University</span>
                </div>

                <div className="sidebar-divider"></div>

                <div className="section-title">APPLICATION</div>

                {/* 🔥 Instruction */}
                <div
                    className={`item ${active === "instruction" ? "active" : ""}`}
                    onClick={() => setActive("instruction")}
                >
                    <FaBookOpen className="icon" />
                    Instruction
                    {step > 1 && <span className="status done">✔</span>}
                </div>

                {/* 🔥 NEW: Program Selection */}
                <div
                    className={`item ${active === "program" ? "active" : ""} ${step < 2 ? "locked" : ""}`}
                    onClick={() => {
                        if (step >= 2) setActive("program");
                    }}
                >
                    <FaLayerGroup className="icon" />
                    Programme Selection
                    {step > 2 && <span className="status done">✔</span>}
                    {step < 2 && <span className="status lock">🔒</span>}
                </div>

                {/* 🔥 Personal Info */}
                <div
                    className={`item ${step < 3 ? "locked" : ""}`}
                    onClick={() => {
                        if (step >= 3) setOpenMenu(!openMenu);
                    }}
                >
                    <FaUser className="icon" />
                    Personal Information
                    <FaChevronRight className={`arrow ${openMenu ? "rotate" : ""}`} />
                    {step < 3 && <span className="status lock">🔒</span>}
                    {step > 5 && <span className="status done">✔</span>}
                </div>

                {/* 🔥 Submenu */}
                <div className={`sub-wrapper ${openMenu ? "open" : ""}`}>

                    <div
                        className={`item ${active === "pi" ? "active" : ""} ${step < 3 ? "locked" : ""}`}
                        onClick={() => step >= 3 && setActive("pi")}
                    >
                        <FaUser className="sub-icon" />
                        Personal Info
                    </div>

                    <div
                        className={`item ${active === "address" ? "active" : ""} ${step < 4 ? "locked" : ""}`}
                        onClick={() => step >= 4 && setActive("address")}
                    >
                        <FaMapMarkerAlt className="sub-icon" />
                        Address
                    </div>

                    <div
                        className={`item ${active === "photo" ? "active" : ""} ${step < 5 ? "locked" : ""}`}
                        onClick={() => step >= 5 && setActive("photo")}
                    >
                        <FaCamera className="sub-icon" />
                        Photo & Signature
                    </div>

                </div>

                <div
                    className={`item ${active === "education" ? "active" : ""} ${step < 6 ? "locked" : ""}`}
                    onClick={() => {
                        if (step >= 6) setActive("education");
                    }}
                >
                    <FaLayerGroup className="icon" />
                    Education
                    {step > 6 && <span className="status done">✔</span>}
                    {step < 6 && <span className="status lock">🔒</span>}
                </div>

                <div
                    className={`item ${active === "centre" ? "active" : ""} ${step < 7 ? "locked" : ""}`}
                    onClick={() => {
                        if (step >= 7) setActive("centre");
                    }}
                >
                    <FaMapMarkerAlt className="icon" />
                    Centre Selection
                    {step > 7 && <span className="status done">✔</span>}
                    {step < 7 && <span className="status lock">🔒</span>}
                </div>

                <div
                    className={`item ${active === "declaration" ? "active" : ""} ${step < 8 ? "locked" : ""}`}
                    onClick={() => {
                        if (step >= 8) setActive("declaration");
                    }}
                >
                    <FaCheckCircle className="icon" />
                    Declaration
                    {step > 8 && <span className="status done">✔</span>}
                    {step < 8 && <span className="status lock">🔒</span>}
                </div>

                <div
                    className={`item ${active === "payment" ? "active" : ""} ${step < 8 ? "locked" : ""}`}
                    onClick={() => {
                        if (step >= 9) setActive("payment");
                    }}
                >
                    <FaCreditCard className="icon" />
                    Online Payment
                    {step > 9 && <span className="status done">✔</span>}
                    {step < 9 && <span className="status lock">🔒</span>}
                </div>

                {/*<div
					className={`item ${active === "report" ? "active" : ""} ${step < 10 ? "locked" : ""}`}
					onClick={() => {
						if (step >= 10) setActive("report");
					}}
				>
					<FaFileAlt className="icon" />
					Application Report
					{step > 10 && <span className="status done">✔</span>}
					{step < 10 && <span className="status lock">🔒</span>}
				</div>*/}

                <div
                    className="item"
                    onClick={() => setDownloadMenu(!downloadMenu)}
                >
                    <FaUser className="icon" />
                    Download
                    <FaChevronRight className={`arrow ${downloadMenu ? "rotate" : ""}`} />
                </div>



                <div className={`sub-wrapper ${downloadMenu ? "open" : ""}`}>

                    <div
                        className={`item ${active === "report" ? "active" : ""}`}
                        onClick={() => setActive("report")}
                    >
                        <FaUser className="sub-icon" />
                        Application Report
                    </div>

                </div>

                <div className={`sub-wrapper ${downloadMenu ? "open" : ""}`}>

                    <div
                        className={`item ${active === "admitcard" ? "active" : ""}`}
                        onClick={() => setActive("admitcard")}
                    >
                        <FaUser className="sub-icon" />
                        Admit Card
                    </div>

                </div>

                <div className={`sub-wrapper ${downloadMenu ? "open" : ""}`}>

                    <div
                        className={`item ${active === "rankcard" ? "active" : ""}`}
                        onClick={() => setActive("rankcard")}
                    >
                        <FaUser className="sub-icon" />
                        Score Card
                    </div>

                </div>



                {/*<div
				            className="item"
				            onClick={() => setComplainMenu(!complainMenu)}
				        >
				            <FaCommentDots className="icon" />
				            Challenge Box
				            <FaChevronRight
				                className={`arrow ${complainMenu ? "rotate" : ""}`}
				            />
				        </div>

				        <div className={`sub-wrapper ${complainMenu ? "open" : ""}`}>
				            <div
				                className={`item ${active === "complaintBox" ? "active" : ""}`}
				                onClick={() => setActive("complaintBox")}
				            >
				                <FaTicketAlt className="sub-icon" />
				                Challenge to Provisional Answer Key
				            </div>
				        </div>*/}


                {/* <div className={`sub-wrapper ${complainMenu ? "open" : ""}`}>

                    <div
                        className={`item ${active === "complaintlist" ? "active" : ""}`}
                        onClick={() => setActive("complaintlist")}
                    >
                        <FaListAlt className="sub-icon" />
                        Complaint List
                    </div>

                </div>*/}





                <div className="sidebar-divider"></div>

                <div
                    className="item logout-btn"
                    onClick={() => {
                        sessionStorage.clear();
                        window.location.href = "/ASTU_JMEE_JLEE/Login";
                    }}
                >

                    <FaSignOutAlt />
                    <span>Logout</span>

                </div>
                <div className="sidebar-footer">
                    ASTU © 2026-27
                </div>

            </div>
        </>
    );
}

export default Sidebar;